/**
 * Слова отказа при сохранении предметов: своих («Мои предметы») и предмета
 * урока. Сырое `e.message` на экран не идёт: там код и английский текст
 * сервера, а читает это преподаватель.
 *
 * Чистая функция по коду, а не по исключению: так её можно проверить без
 * клиента API. Код достаёт вызывающий (`ApiError.code`), `null` это «не отказ
 * API» (сеть, таймаут).
 */
export function subjectSaveErrorText(code: string | null): string {
  if (code === "subject_not_taught") {
    return "Этого предмета больше нет в вашем списке. Обновите страницу.";
  }
  return "Не сохранилось, попробуйте ещё раз.";
}
